export default function ({ store, route, redirect }) {
  // Check if the route has a meta field with required features
  // route.meta is an array and find the first instance of requiredFeatures
  const required = route.meta.find(m => 'requiredFeatures' in m)

  if (!required) return // No feature required

  // Normalize to an array
  const requiredFeatures = Array.isArray(required.requiredFeatures) ? required.requiredFeatures : [required.requiredFeatures]

  // Check if all required features are present
  const hasAll = requiredFeatures.every((feature) =>
    store.getters['user/allEnabledFeatures'].includes(feature)
  )

  if (!hasAll) {
    return redirect('/');
  }
}
